import * as angular from 'angular';

export const ValidDate = () => (<angular.IDirective>{

  require: 'ngModel',

  link: function (scope: angular.IScope, element: any, attr: any, mCtrl: angular.INgModelController) {
    function isDateLessThanToday(date: string) {
      const isValid = Date.parse(date) <= new Date().getTime();
      mCtrl.$setValidity('dateTodayE', isValid);

      return date;
    }

    mCtrl.$parsers.push(isDateLessThanToday);
  },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/validate-date/validate-date.directive.ts